module.exports = __webpack_public_path__ + "bb07de647e8df5cbd532257ffd545edc.MP3";